import { Component, OnInit, Inject, Input } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from 'src/app/modules/organization/connection.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CommonModule, Location } from '@angular/common';
import { BoxService } from 'src/app/shared/services/box.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ObjectExplorerService } from 'src/app/shared/object-explorer/object-explorer.service';
import { InputparameterDialogComponent } from '../inputparameter-dialog/inputparameter-dialog.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ListPanelModule } from 'src/app/bloom/specialized-panels/list-panel/list-panel.module';
import { SnackbarModule } from 'src/app/shared/snackbar/snackbar.module';
import { SnackbarComponent } from 'src/app/shared/snackbar/snackbar.component';
import { SpinnerModule } from 'src/app/shared/spinner/spinner.module';

interface snackBarValues {
  snackBarMessage: string;
  snackBarIcon?: string;
  snackBarError?: boolean;
  snackBarDuration?: number;
  snackBarRecommendation?: string
}

@Component({
    selector: 'events-listing',
    templateUrl: './events-listing.component.html',
    styleUrls: ['./events-listing.component.css'],
    imports: [
        MatTooltipModule,
        MatExpansionModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatChipsModule,
        FlexLayoutModule,
        CommonModule,
        ListPanelModule,
        SnackbarModule,
        SpinnerModule
        // SnackbarComponent
    ]
})

export class EventsListingComponent implements OnInit {
  constructor(
    private _snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private connectionService: ConnectionService,
    private dialog: MatDialog,
    private location: Location,
    private boxService: BoxService,
    private objectExplorerService: ObjectExplorerService
  ) {}

  @Input() connection: any
  @Input() box: any

  events: any[] = []
  filteredEvents: any[] = []
  result: any[] = []
  actionResults: { event: any, result: any[] }[] = []  // array containing the results of all the executed functions
  openResultIndex: number = -1 
  eventsLoaded: boolean = false
  spinner: boolean = false

  ngOnInit(): void {
    console.log("connection", this.connection)
    console.log("box", this.box)
    this.getEvents()
  }

  async getEvents() {
    if(!this.box.supports.includes("event")) {
      this.events = []
      this.eventsLoaded = true
      return
    }
    this.spinner = true
    try {
      this.events = await this.boxService.getEvents(
        this.connection.box_id,
        this.connection._id
      );
      
      this.spinner = false
      // set cache
      // if (this.events?.length){
      //   this.connectionService.eventsCache[this.connection._id] = this.events
      // }

    } catch (error) {
      console.error('Could not fetch events :', error);
      this.openSnackBar({
        snackBarMessage: "Could not fetch events",
      }, error)
      this.spinner = false
      throw error
    }
    this.filteredEvents = JSON.parse(JSON.stringify(this.events))
    this.eventsLoaded = true
    console.log('EVENTS', this.events);
  }
  trackByFn(index:number, item:any):any{
    return item || index
  }

  searchEvents(event: any){
    if(event.srcElement.value == ''){
      this.filteredEvents = JSON.parse(JSON.stringify(this.events))
      return
    }
    this.filteredEvents = []
    for (let i = 0; i < this.events.length; i++) {
      if(this.events[i].name.toLowerCase().includes(event.srcElement.value)){
        this.filteredEvents.push(this.events[i])
      }
    }
  }

  openSnackBar(snackBarObj: snackBarValues, error: any){
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: {
        title: error?.error?.error?.name || '',
        description: error?.error.error.message || JSON.stringify(error?.error.error) || error?.error?.message || '',
        recommendation: snackBarObj?.snackBarRecommendation || '',
        message: snackBarObj.snackBarMessage,
        iconname: snackBarObj.snackBarIcon,
        isError: true
      },
      duration: snackBarObj.snackBarDuration || undefined,
      horizontalPosition: 'end',
    });
  }
}
